import { useTeamContext } from "@/Common/Contex/TeamContext";
import useConfig from "@/hooks/useConfig";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
} from "@mui/material";
import { ReactNode } from "react";

interface CommonTableProps {
  headers: {
    id: string;
    label: string | ReactNode;
    align?: "left" | "center" | "right";
    width?: string | number;
  }[];
  rows: any[];
  renderCell?: (row: any, columnId: string, index: number) => ReactNode;
  emptyMessage?: string;
  maxHeight?: string | number;
  stickyHeader?: boolean;
  tableProps?: any;
  headerRowProps?: any;
  bodyRowProps?: any;
  title?: string;
}

const StyledTableCell = styled(TableCell)(({ theme }: any) => ({
  fontWeight: 600,
  padding: "8px 16px",
  //   backgroundColor: theme.palette.grey[200],
}));

const CommonTable = ({
  headers,
  rows,
  renderCell,
  emptyMessage = "No data available",
  maxHeight = 400,
  stickyHeader = true,
  tableProps,
  headerRowProps,
  bodyRowProps,
  title,
}: CommonTableProps) => {
  const { setCurrentSelectedTeam, currentSelectedTeam }: any = useTeamContext();
  const config = useConfig();
  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h6" sx={{ py: 1 }}>
        {title}
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: maxHeight,
          boxShadow: 1,
          borderRadius: 1,
          overflow: "auto",
        }}
      >
        <Table stickyHeader={stickyHeader} {...tableProps}>
          <TableHead>
            <TableRow {...headerRowProps}>
              {headers.map((header) => (
                <StyledTableCell
                  key={header.id}
                  align={header.align || "left"}
                  sx={{
                    width: header.width || "auto",
                    bgcolor:
                      currentSelectedTeam?.team_primary_color || config.primary,
                    color: config.tertiary,
                  }}
                >
                  {header.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, rowIndex) => (
                <TableRow
                  key={rowIndex}
                  {...(typeof bodyRowProps === "function"
                    ? bodyRowProps(row, rowIndex)
                    : bodyRowProps)}
                  hover
                >
                  {headers.map((header) => (
                    <TableCell
                      key={`${rowIndex}-${header.id}`}
                      align={header.align || "left"}
                    >
                      {renderCell
                        ? renderCell(row, header.id, rowIndex)
                        : row[header.id] || "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={headers.length} align="center">
                  <Typography variant="body2" sx={{ py: 2 }}>
                    {emptyMessage}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CommonTable;
